import React from 'react';
import './FormStyles.css';

export default function CheckboxInput({
  label,
  name,
  checked = false,
  onChange,
  error,
  disabled = false,
  className = '',
}) {
  return (
    <div className={`form-group form-checkbox-group ${className}`}>
      <label htmlFor={name} className="checkbox-label">
        <input
          id={name}
          type="checkbox"
          name={name}
          checked={checked || false}
          onChange={onChange}
          disabled={disabled}
          className="checkbox-input"
        />
        <span className="checkbox-text">{label}</span>
      </label>
      {error && <div className="form-error">{error}</div>}
    </div>
  );
}
